import { useTranslation } from 'react-i18next';
import { SvgIcon } from '../svg-icon/svg-icon';
import './loading.scss';

type LoadingProps = {
	children: React.ReactNode;
	isLoading: boolean;
};

export const Loading: React.FC<LoadingProps> = ({ children, isLoading }) => {
	const { t } = useTranslation();

	return (
		<>
			{isLoading ? (
				<div className='bookr-spinner'>
					<SvgIcon name='spinner' size={50} />
					{t('common.loading')}
				</div>
			) : (
				children
			)}
		</>
	);
};
